import axios from "../axios";
import { showToaster } from "../helpers/toaster.helpers";

const sendEvent = (payload, userOffline) => {
  if (userOffline) {
    return;
  }
  axios.post("events/send", payload);
};

export const socketServices = {
  sendEvent,
};
